import React from "react";
import MarketingPage from "@/components/MarketingPage";

export default function ToolPdfToFlashcards() {
  return (
    <MarketingPage
      testid="tool-pdf-to-flashcards"
      tag="free pdf tool"
      h1="Free PDF to Flashcards Converter Online"
      intro="Turn any PDF into a set of study flashcards in seconds — free, online, and with no software to install. Loom reads your textbooks, lecture notes and revision guides and converts them into active-recall flashcards you can actually remember."
      ctaText="Convert my PDF free"
      sections={[
        {
          h2: "Convert textbooks and notes into study aids",
          body: [
            "Loom is a free online PDF to flashcards converter built for students and exam candidates who are drowning in long documents. Instead of re-reading a 300-page textbook over and over, you upload the PDF once and Loom breaks it into clear study sections and auto-generates flashcards, multiple-choice questions and recall prompts straight from your own material.",
            "Because every card is generated from the exact content of your document, you never study generic trivia — you revise the precise definitions, formulas, dates and concepts that appear in your syllabus. That keeps revision focused and makes it far easier to walk into an exam confident about what you have covered.",
          ],
        },
        {
          h2: "How the PDF to flashcards converter works",
          body: [
            "Upload any PDF up to 1000 pages — a chapter, a full textbook, class slides, a research paper or professional study material. Loom slices it into bite-sized, self-contained sections, then creates flashcards and quizzes for each one so you can test yourself as you go.",
            "You can flip through flashcards, answer MCQs, and use spaced active-recall prompts to lock the material into long-term memory. Every card references the page it came from in the original PDF, so you can always check the source while you revise.",
          ],
        },
        {
          h2: "Study smarter, remember longer",
          body: [
            "Flashcards work because they force your brain to retrieve information instead of passively re-reading it. Loom automates the slowest part — writing the cards — so you spend your time studying, not formatting. Start free, convert your first PDFs into flashcards with no card required, and upgrade only when you want unlimited decks and exports to PDF or PowerPoint.",
          ],
        },
      ]}
    />
  );
}
